export const saveOfferDraft = () => ({
  action: 'save-offer-draft',
});
